export const Permiss = {
  设备总览: '10010000',
  昨日新增数据: '10020000',
  总览数据: '10030000',
  折线图统计数据: '10040000',
  增加客户: '11010100',
  编辑客户: '11010200',
  删除客户: '11010300',
  增加供应商: '11020100',
  编辑供应商: '11020200',
  删除供应商: '11020300',
  增加用户: '11030100',
  编辑用户: '11030200',
  删除用户: '11030300',
  重置密码: '11030400',
  新增角色: '11040100',
  分配权限: '11040200',
  编辑角色: '11040300',
  删除角色: '11040400',
  增加设备: '12010100',
  编辑设备: '12010200',
  删除设备: '12010300',
  转移设备: '12010400',
  升级设备子系统软件: '12010500',
  查看参数: '12010600',
  下发参数: '12010700',
  查看设备转移记录: '12010800',
  查看参数控制记录: '12010900',
  查看故障处理人: '12011000',
  下载许可证: '12011100',
  更改故障处理人: '12011200',
  查看设备信息: '12011300',
  查看升级记录: '12011400',
  新增设备型号: '12020100',
  编辑设备型号: '12020200',
  删除设备型号: '12020300',
  查看设备型号参数列表: '12020400', //
  一键导入参数: '12020401',
  新增参数: '12020402',
  编辑参数: '12020403',
  删除参数: '12020404',
  下载参数模板: '12020405',
  新增报警: '13010100',
  编辑报警: '13010200',
  删除报警: '13010300',
  查看操作处理流程: '14010100',
  保存任务: '14010400',
  转发任务: '14010500',
  完成任务: '14010600',
  新增版本: '15010100',
  作废版本: '15010200',
  导出制片机日报月报和年报: '17010100',
  导出报警日报月报和年报: '17020100',
  导出AI分析日报月报和年报: '17030100',
  导出扫描仪日报月报和年报: '17040100'
}

let loginUserInfo
const ids = []

export function getLoginUserInfo () {
  if (loginUserInfo === undefined) {
    const roles = localStorage.user_roles.split(',')
    loginUserInfo = {
      user_name: localStorage.user_name,
      user_rights: localStorage.user_rights.split(','),
      user_roles: roles,
      is_root: roles.includes('0'),
      isSystemRole: roles.includes('0') || roles.includes('1'),
      isOnlyAfterSalesManage: localStorage.user_roles === '4'
    }
  }
  return loginUserInfo
}

export function setLoginUserInfo () {
  loginUserInfo = undefined
  ids.splice(0)
}

export function hasRight (name) {
  return getLoginUserInfo().user_rights.indexOf(Permiss[name]) >= 0
}

export function operationsFilter (arr) {
  return arr.filter(it => hasRight(it.permiss))
}
